import styled from 'styled-components';

export const InputWrapper = styled.div`
  background-color: ${({ theme }) => theme.white};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  border-bottom-right-radius: 6px;
  border-top: 1px solid #E0E0E0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;  
`

export const Popup = styled.div`
  background-color: ${({ theme }) => theme.white};
  width: 300px;
  padding: 8px 20px;
  border-radius: 6px;
  box-shadow: 0 7px 15px 0 rgba(0, 0, 0, 0.1);
  display: ${({ show }) => show};
  position: absolute;
  bottom: 58px;
  left: 15px;
`

export const IconWrapper = styled.span`
  width: 24px;
`

export const FilenameWrapper = styled.div.attrs({
  className: 'col-10 px-0'
})`
  align-content: flex-start;
`
